import { render } from "./CertificatePreview.vue?vue&type=template&id=91ef377a&scoped=true"
import script from "./CertificatePreview.vue?vue&type=script&lang=js"
export * from "./CertificatePreview.vue?vue&type=script&lang=js"

import "./CertificatePreview.vue?vue&type=style&index=0&id=91ef377a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ef377a"]])

export default __exports__